var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M83.8641 20.8652H68.0619C71.9013 20.86 75.0946 17.7247 75.0998 13.8853C75.105 10.0458 71.9966 6.9375 68.1572 6.94268C68.1628 2.62521 64.2313 -0.767823 59.7504 0.15167C56.4877 0.821043 54.2349 3.84939 54.2349 7.18021V8.57945C53.1841 7.63181 51.8075 7.03824 50.2843 7.03824H42.3832C40.86 7.03824 39.4835 7.63181 38.4327 8.57945V7.18021C38.4327 3.84915 36.1799 0.821043 32.9169 0.151424C28.436 -0.768069 24.5045 2.62497 24.5102 6.94244C20.6709 6.93725 17.5626 10.0456 17.5675 13.885C17.573 17.7247 20.7663 20.86 24.6057 20.8652H8.80346C4.43982 20.8652 0.902344 24.4027 0.902344 28.7663V30.7416C0.902344 35.1052 4.43982 38.6427 8.80346 38.6427H32.5068V42.5933H6.82818V82.4149C6.82818 86.604 10.2242 90 14.4133 90H32.5068C34.6888 90 36.4574 88.2314 36.4574 86.0494V22.8405H56.2102V86.0494C56.2102 88.2314 57.9788 90 60.1607 90H78.2543C82.4434 90 85.8394 86.604 85.8394 82.4149V42.5933H60.1607V38.6427H83.8641C88.2277 38.6427 91.7652 35.1052 91.7652 30.7416V28.7663C91.7652 24.4027 88.2277 20.8652 83.8641 20.8652ZM40.4079 18.8899V12.9641C40.4079 11.8752 41.2934 10.9888 42.3832 10.9888H50.2843C51.3742 10.9888 52.2596 11.8752 52.2596 12.9641V18.8899H40.4079Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetGift);
export default __webpack_public_path__ + "static/media/getGift.7e2fb59e4793cb2ed314a9bad2a104a8.svg";
export { ForwardRef as ReactComponent };